import { getBookingFlowAnalyticsCollectorUrl } from '../firebase/runtimeEndpoints.ts';
import type { BookingFlowAnalyticsWriter } from './bookingFlowAnalyticsEmitter.ts';

export const createBookingFlowAnalyticsPublicCollectorWriter = (
  collectorUrl = getBookingFlowAnalyticsCollectorUrl(),
  fetchImpl: typeof fetch = fetch,
): BookingFlowAnalyticsWriter => async event => {
  const body = JSON.stringify({ event });
  for (let attempt = 0; attempt < 2; attempt += 1) {
    try {
      const response = await fetchImpl(collectorUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body,
        keepalive: true,
      });
      if (response.ok || (response.status !== 429 && response.status < 500)) return;
    } catch {
      // One exact retry is allowed below; analytics must never block booking.
    }
  }
};
